"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.RefreshTokenCSR = void 0;
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// eslint-disable-next-line max-classes-per-file
const REFRESH_TOKEN_CHANGED = 'refresh_token_changed';
let _RefreshTokenCSR = /*#__PURE__*/(0, _createClass2.default)(function _RefreshTokenCSR() {
  (0, _classCallCheck2.default)(this, _RefreshTokenCSR);
});
if (process.browser || typeof window !== 'undefined') {
  _RefreshTokenCSR = /*#__PURE__*/function (_EventTarget) {
    (0, _inherits2.default)(_RefreshTokenCSR, _EventTarget);
    var _super = _createSuper(_RefreshTokenCSR);
    function _RefreshTokenCSR(...args) {
      var _this;
      (0, _classCallCheck2.default)(this, _RefreshTokenCSR);
      _this = _super.call(this, ...args);
      _this._getting_refresh_token = false;
      return _this;
    }
    (0, _createClass2.default)(_RefreshTokenCSR, [{
      key: "isGettingRefreshToken",
      get: function () {
        return this._getting_refresh_token;
      }
    }, {
      key: "startGettingRefreshToken",
      value: function startGettingRefreshToken() {
        console.log('startGettingRefreshToken');
        this._getting_refresh_token = true;
        this.dispatchEvent(new CustomEvent(REFRESH_TOKEN_CHANGED, {
          detail: {
            finishedGettingRefreshToken: !this._getting_refresh_token
          }
        }));
      }
    }, {
      key: "endGettingRefreshToken",
      value: function endGettingRefreshToken() {
        console.log('endGettingRefreshToken');
        this._getting_refresh_token = false;
        this.dispatchEvent(new CustomEvent(REFRESH_TOKEN_CHANGED, {
          detail: {
            finishedGettingRefreshToken: !this._getting_refresh_token
          }
        }));
      }
    }, {
      key: "waitForRefreshToken",
      value: function waitForRefreshToken() {
        return new Promise(resolve => {
          const eventHandler = e => {
            console.log('got refresh token event listener');
            if (e.detail.finishedGettingRefreshToken) {
              this.removeEventListener(REFRESH_TOKEN_CHANGED, eventHandler);
              resolve();
            }
          };
          this.addEventListener(REFRESH_TOKEN_CHANGED, eventHandler);
        });
      }
    }]);
    return _RefreshTokenCSR;
  }( /*#__PURE__*/(0, _wrapNativeSuper2.default)(EventTarget));
}
const RefreshTokenCSR = _RefreshTokenCSR;
exports.RefreshTokenCSR = RefreshTokenCSR;